import EToast from '@/components/everridge/EToast';
import CopyIcon from '@/components/icons/CopyIcon';
import TickIcon from '@/components/icons/TickIcon';
import { t } from 'i18next';
import { FC, PropsWithChildren, useState } from 'react';

type Props = {
	type?: string;
	className?: string;
};

const ECreateDetailsCopyItem: FC<PropsWithChildren<Props>> = ({
	type = 'Element',
	children,
	className,
}) => {
	const [copied, setCopied] = useState<boolean>(false);

	if (!children) return null;

	const getCopyElement =
		typeof children === 'string'
			? children
			: Array.isArray(children)
			? children[1]
			: '';

	const copyElementHandler = () => {
		navigator.clipboard.writeText(getCopyElement);
		setCopied(true);
		setTimeout(() => setCopied(false), 500);
		EToast({
			variant: 'success',
			message: t('main.owners.toasts.copy.message'),
			description: `${type} ${t('main.owners.toasts.copy.description')}`,
		});
	};

	return (
		<button
			className={`px-3 py-2 rounded-full flex items-center gap-1.5 bg-popover-50  ${className} select-none`}
			onClick={copyElementHandler}>
			{children}
			<div className='relative size-5'>
				<CopyIcon
					className={`absolute transition-all duration-100 ${
						copied ? 'opacity-0' : 'opacity-100'
					}`}
				/>
				<TickIcon
					className={`absolute transition-all duration-100 ${
						copied ? 'opacity-100' : 'opacity-0'
					}`}
				/>
			</div>
		</button>
	);
};

export default ECreateDetailsCopyItem;
